import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { PostAPI, localStorageData } from '../../Api/ApiConfig';
import CustomInput from '../../Components/CustomInput';
import CustomButton from '../../Components/CustomButton';
import { setAccessToken } from '../../Util/authHeader';
import { setUserDetails } from '../../Store/Slices/UserSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const VerifyModal = ({ coupon, verifiedCoupon }) => {
    const userPrompts = useSelector((state) => state.user.userPrompts);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.user.userDetails);
    const { t } = useTranslation();

    const [emailConfig, setEmailConfig] = useState({ error: false, error_msg: "", isShow: true, code: '', loading: false });

    const confirmEmail = async (e) => {
        e.preventDefault();
        setEmailConfig({ ...emailConfig, 'loading': true, error: false });
        try {
            // const user = await localStorageData();
            debugger
            const data = new FormData();
            data.append("email", user.email);
            data.append("code", emailConfig.code);
            debugger
            const res = await PostAPI('/api/user/verify_email/', data);
            setEmailConfig({ ...emailConfig, 'loading': false });
            if (!res.data.error) {
                if (coupon === "coupon") {
                    verifiedCoupon();
                    setEmailConfig({ ...emailConfig, 'isShow': false });
                } else {
                    localStorage.setItem("user", JSON.stringify(res?.data?.data[0]));
                    dispatch(setUserDetails(res.data.data[0]));
                    if (res.data.data[0].status === "lead") {
                        navigate("/subscription");
                    } else {
                        if (res.data.data[0].token) {
                            navigate("/download-app");
                        }
                    }
                    setEmailConfig({ ...emailConfig, 'isShow': false });
                }
            } else {
                setEmailConfig({ ...emailConfig, 'error': true, error_msg: t("auth.verifyModal.invalidCode"), });
            }
        } catch (error) {
            setEmailConfig({ ...emailConfig, 'error': true, error_msg: t("auth.verifyModal.invalidCode"), });
        }
    }

    return (
        <Modal
            show={emailConfig.isShow}
            centered
            className="email-confirm-modal"
            backdrop="static"
        >
            <Modal.Body>
                <form className="w-100 px-4 py-5" >
                    <div className="row">
                        <div className="col-12">
                            <p className="lightColor mx-auto w-50 text-center font-16 lh-16 whiteColor fw-bold">
                                {userPrompts?.email_verfication_message}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 customiseModal">
                            <CustomInput
                                placeholder={t("auth.verifyModal.placeholder")}
                                required
                                id="code"
                                type="text"
                                labelClass="mainLabel"
                                inputClass="mainInput"
                                onChange={(event) => { setEmailConfig({ ...emailConfig, 'code': event.target.value, error: false }) }}
                            />
                        </div>
                    </div>
                    {emailConfig.error && (
                        <div className="row">
                            <div className="col-12">
                                <p className="smallText lightColor text-center">{userPrompts?.forget_otp_sent_msg ||  emailConfig.error_msg || t("auth.verifyModal.invalidCode")}</p>
                            </div>
                        </div>
                    )}
                    <div className="row mt-3 text-center">
                        <div className="col-12">
                            {
                                emailConfig.loading ? (
                                    <button className="primaryButton customButton">
                                        <div className="spinner-border spinner-border-sm text-dark" role="status"></div>
                                    </button>
                                )
                                    : (
                                        <CustomButton
                                            variant="primaryButton"
                                            text={t("auth.verifyModal.submit")}
                                            onClick={confirmEmail}
                                        />
                                    )
                            }
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default VerifyModal